import { render, staticRenderFns } from "./VoyageDetails.vue?vue&type=template&id=2f5f0ee8&scoped=true&"
import script from "./VoyageDetails.vue?vue&type=script&lang=js&"
export * from "./VoyageDetails.vue?vue&type=script&lang=js&"
import style0 from "./VoyageDetails.vue?vue&type=style&index=0&id=2f5f0ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f0ee8",
  null
  
)

export default component.exports